// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

// Janine Linde Makelaars brand palette, sampled from the brokerage's own
// marketing material: coral-rose as the lead colour (Janine's pink), deep
// brick/maroon kept only as a secondary accent (matches the logo wordmark),
// charcoal for body text, blush-pink washes for soft fills.
export default createVuetify({
  // An alert inside a dialog card (a flex column) must never be squeezed to one line by a short window: it keeps its height.
  defaults: {
    VAlert: { class: 'flex-shrink-0' },
  },
  theme: {
    defaultTheme: 'janineLinde',
    themes: {
      janineLinde: {
        dark: false,
        colors: {
          primary: '#F0848F',
          secondary: '#2E2E2E',
          accent: '#B5282B',
          background: '#FAF6F5',
          surface: '#FFFFFF',
          error: '#E0607E',
        },
      },
    },
  },
})
